import { useState } from "react";

import { isProPreview } from "./proPreview";

// Видно ли платное (`proPreview`). Метка меняется только загрузкой страницы по ссылке, поэтому
// читается один раз.
export const useProPreview = (): boolean => {
  const [enabled] = useState(isProPreview);
  return enabled;
};
